import { Box, Button, IconSubCategory } from 'braid-design-system';

import * as styles from './ReplyButton.css';

export default ({ onCommentClick }: { onCommentClick?: () => void }) => (
  <Box borderRadius="full" padding="xxsmall" className={styles.ReplyButton}>
    <Button
      variant="transparent"
      tone="neutral"
      icon={<IconSubCategory />}
      onClick={onCommentClick}
    >
      {' '}
      Reply
    </Button>
  </Box>
);
